import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams, AlertController } from 'ionic-angular';
import { DatabaseProvider } from '../../providers/database/database';
import { Observable } from "rxjs/Observable";
import * as _ from 'lodash';
import { AngularFireFunctions } from 'angularfire2/functions';
import { Storage } from '@ionic/storage';
import { AdminProvider } from '../../providers/admin/admin';
import { AuthProvider } from '../../providers/auth/auth';
import { Subject } from 'rxjs';

interface UserProperties {
  program_id ? : string;
  clinic_name ? : string;
  email ? : string;
  password ? : string;
  phone ? : string;
  name ? : string;
}

@IonicPage()
@Component({
  selector: 'page-admin-utility',
  templateUrl: 'admin-utility.html',
})

export class AdminUtilityPage {
  private ngUnsubscribe: Subject<any> = new Subject();
  document_path: string = 'clinics/';
  document_id: string = 'EA9TDWfZgBVNfXhGXYzG'
  document_path_new: string = '';
  document_id_new: string = '';
  document: any;

  collection_path: string = '';
  collection_path_new: string = '';
  collection: any;

  public clinicList: Observable<any[]>;
  clinic: string;
  clinic_name: string;
  program_id: string;
  program_name: string

  user: any = {};

  json: string;
  program_admin_doc: string;

  constructor(
    public navCtrl: NavController, 
    public navParams: NavParams, 
    private database: DatabaseProvider, 
    private afFun: AngularFireFunctions, 
    private storage: Storage,
    private alertCtrl: AlertController,
    private db: AdminProvider,
    private auth: AuthProvider
    ) {

      this.auth.getCurrentUser().then(user => {
        this.program_name = user.program_name;
        this.program_id = user.program_id;

        this.user = { id: user.id, name: user.first_name + ' ' + user.last_name }
      });
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad AdminUtilityPage');
  }

  ngOnDestroy() {
    console.log('Leave patient tasks and destroy subscriptions');
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }

  clearOrders() {
    this.storage.remove('RetinaOrderBatch').then(() => {
      let alert = this.alertCtrl.create({
        title: "Orders Removed",
        subTitle: "The batch of orders has been cleared",
        buttons: ["OK"]
      });
      alert.present();
      alert.onDidDismiss(() => {})
    });
  }

  getDoc()  {
    console.log(this.document_path)
    this.database.getDoc(this.document_path, this.document_id)
    .valueChanges()
    .subscribe((data) => {
      console.log(data);
      this.document = JSON.stringify(data);
    })
  }

  updateDoc() {
    this.database.updateDoc(this.document_path, this.document_id, JSON.parse(this.document))
  }

  setDoc()  {
    this.database.setDoc(this.document_path_new, this.document_id_new, JSON.parse(this.document))
  }

  setDocWithID() {
    this.database.setDocWithID(this.document_path_new, JSON.parse(this.document))
  }

  getCollection() {
    console.log(this.collection_path)
    this.database.getCollection(this.collection_path)
    .snapshotChanges()
    .takeUntil(this.ngUnsubscribe)
    .subscribe((data) => {
      console.log(data);

      let cache: any;
      this.collection = JSON.stringify(data, function(key, value) {
        if (typeof value === 'object' && value !== null) {
            if (cache.indexOf(value) !== -1) {
                // Circular reference found, discard key
                return;
            }
            // Store value in our collection
            cache.push(value);
        }
  return value;
});
    })
  }

  setCollection() {
    let parseJSON = JSON.parse(this.collection)

    _(parseJSON).forEach((item) => {
      let document = _.omit(item, ['id']);
      this.database.setDocWithID(this.collection_path_new, document).then(_ => {
        console.log("Doc added: ", document);
      })
      .catch((err) => {
        console.log("Error adding document: ", document);
      })

    });

  }

  async createTestUser()  {
    console.log("Creating test user:", this.user)
      // Angular Fire - Converts Promise to Observable
    let testuser: UserProperties = {program_id: "3serdsdff3446", clinic_name: "Test Clinic", email: null, password: null, phone: null, name: null};
    testuser.email = this.user.email;
    testuser.password = this.user.password;
    testuser.phone = this.user.phone;
    testuser.name = this.user.name;

    console.log("Creating test user properties:", testuser);

    const respRef = await this.afFun.httpsCallable('addUser')(testuser).toPromise();
    console.log(respRef)
  }

  uploadJson()  {
    const json = JSON.parse(this.json);
    this.db.uploadJson(this.program_id, this.program_admin_doc, json, this.user)
  }

}



// WEBPACK FOOTER //
// ./src/pages/admin-utility/admin-utility.ts